import React from "react";

export default function FeatureCard({ icon, description }) {
  return (
    <div className="bg-[#A27A1A] text-white w-full h-full flex items-center justify-center px-6">
      <div className="flex flex-col items-center text-center">
        {icon && (
          <img
            src={icon}
            alt=""
            className="
              w-[120px]
              h-[120px]
              object-contain
              mb-6
              transition-all duration-500
              group-hover:scale-110
              group-hover:-rotate-3
            "
            loading="lazy"
          />
        )}

        <p className="text-[12px] md:text-[14px] font-creto font-medium leading-snug max-w-[260px]">
          {description}
        </p>
      </div>
    </div>
  );
}
